import React from 'react';

import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';

import { ProgressWithLabelProgressWrap, ProgressWithLabelWrap } from './style';

export default function ProgressWithLabel({
	value,
	...props
}: LinearProgressProps & { value: number }) {
	return (
		<ProgressWithLabelWrap>
			<ProgressWithLabelProgressWrap>
				<LinearProgress
					variant="determinate"
					sx={{ borderRadius: '9px' }}
					value={value}
					{...props}
				/>
			</ProgressWithLabelProgressWrap>
			<Box>
				<Typography variant="body2">{`${Math.round(value)}%`}</Typography>
			</Box>
		</ProgressWithLabelWrap>
	);
}
